import {EventBase} from "shared/utilities/Events/EventManager";

export class UpdateFieldSettingsPanel extends EventBase {
    ReturnType: void;

    constructor() {
        super();
    }

    public static GetName() {
        return 'UpdateFieldSettingsPanel';
    }
}